<template>
  <div class="nrcvMainDiv">
    <div style="height: 40px; text-align: center; border-bottom: 1px solid #00000033;">
      <el-radio-group v-model="useCompany" @change="radioChange" size="small">
        <el-radio-button label="282731097475776512">施工</el-radio-button>
        <el-radio-button label="282731283119865856">监理</el-radio-button>
      </el-radio-group>
    </div>
    <div style="height: 80vh;" v-loading="loading">
      <split-pane v-on:resize="resize" :min-percent='0' :default-percent='20' :max-percent='50' split="vertical">
        <template slot="paneL">
          <div style="height: 100%; overflow-x: auto;">
            <el-tree
              lazy
              ref="tree"
              v-if="treeStatus"
              :load="loadProNode"
              :props="defaultProps"
              node-key="id"
              highlight-current
              :default-expanded-keys="expandedKeys"
              :expand-on-click-node="false"
              @node-click="handleNodeClick" >
                          <span class="custom-tree-node" slot-scope="{ node, data }">
                            <span v-if="data.hasOwnProperty('docself') && 'null' !== data.docself && parseInt(data.docself) > 0"  style="font-size:14px; color: green;">
                              {{ (data.otherInfo.sjpro == "1" ? ("<" + "首件工程" +  ">") : "") + node.label }}
                            </span>
                            <span v-else-if="data.doc > 0 || (data.doc !== 'null' && parseInt(data.doc) > 0)"  style="font-size:14px; color: blue;">
                              {{ (data.otherInfo.sjpro == "1" ? ("<" + "首件工程" +  ">") : "") + node.label }}
                            </span>
                            <span v-else  style="font-size:14px;">
                              {{ (data.otherInfo.sjpro == "1" ? ("<" + "首件工程" +  ">") : "") + node.label }}
                            </span>
                          </span>
            </el-tree>
          </div>
        </template>
        <template slot="paneR">
          <related-construction-view2 ref="relatedConstructionView" :projectId="projectId" :sectionId='sectionId' :use-company="useCompany" :directory-id="directoryId" :quality-inst-id="qualityInstId"></related-construction-view2>
        </template>
      </split-pane>
    </div>
  </div>
</template>

<script>
  import {getPathByCode, getPrjPartApiByName, getPrjPartApiById} from "../../api/prjPart";
  import RelatedConstructionView2 from "./RelatedConstructionView2";

  export default {
    name: "NewRelatedConstructionView",
    components: {RelatedConstructionView2},
    props: {
      projectId: {
        type: String,
        default: "",
        required: true
      },
      sectionId: {
        type: String,
        default: "",
        required: true
      },
      prjCode: {
        type: String,
        default: "",
      },
      sectionCode: {
        type: String,
        default: "",
      },
      templeId: {
        type: String,
        default: "",
      },
      directoryId: {
        type: String,
        default: ''
      },
      qualityInstId: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        partCode: '',
        loading: false,
        treeStatus: false,
        expandedKeys: [],
        useCompany: '282731097475776512',
        defaultProps: {
          value: "id",
          children: "children",
          isLeaf: "leaf",
          checked: "false",
          label: "label"
        },
      }
    },
    methods: {
      resize() {
        if (this.$children[0].percent > 50) {
          this.$children[0].percent = 50;
        }
      },
      radioChange(value) {
        this.useCompany = value;
        this.update(this.partCode);
      },
      update(partCode) {
        this.partCode = partCode;
        this.expandedKeys = [];

        this.loading = true;

        this.treeStatus = false;
        this.$nextTick(() => {
          this.treeStatus = true;
          this.getPathByCode();
        })
      },
      //获取全部分部分项
      getPathByCode() {
        getPathByCode(this.partCode).then(res => {
          let tempArr = [];
          res.data.forEach(row => {
            if (row.code != this.partCode) {
              tempArr.push(row.code);
            }
          });
          this.expandedKeys = tempArr;
          if (this.expandedKeys.length === 0) {
            this.$message.warning('对应工程划分部位已被删除!');
            this.loading = false
          }
        })
      },
      //分部分项加载
      loadProNode(node, resolve) {
        var id = this.sectionCode;
        if (node.data != undefined) {
          id = node.data.id;
        }

        let params = {useCompany: this.useCompany};

        getPrjPartApiById(id, this.$qs.stringify(params)).then(response => {
          if (response != null && response.length > 0) {
            response.filter(it => {
              it.label = it.text;
              if (it.state == "closed") {
                it.leaf = false;
              } else {
                it.leaf = true;
              }

              if (it.id == this.partCode) {
                this.$nextTick(() => {
                  this.$refs.tree.setCurrentKey(it.id);
                  this.handleNodeClick(it);
                  this.loading = false;
                });
              }
            });
            return resolve(response);
          }
        });
      },
      //左边树点击
      handleNodeClick(data) {
        this.$refs.relatedConstructionView.getQualityInspectionDataTableData(data);
      },
    }
  }
</script>

<style scoped>
  .nrcvMainDiv {
    height: calc(80vh + 40px);
  }
</style>
<style>
  .nrcvMainDiv .splitter-pane {
    box-sizing: border-box;
  }
</style>



// WEBPACK FOOTER //
// src/components/todo/NewRelatedConstructionView.vue